import TimeLabel from "./TimeLabel";
export default TimeLabel;
